import { memo } from 'react';
import cn from 'classnames';
import { Box, Element, Image } from 'src/components';
import RouterLink from 'src/components/links';
import { IContent } from 'src/interface';
import { ContentList } from 'src/modules/content/components/list';
import { ArrayUtils } from 'src/utils';

interface IProps {
    className?: string;
    thumbnail: string;
    title: string;
    items: IContent[];
    url: string;
    style: any;
    styleBanner: any;
    displayTimeIn: number;
}

export const AdTopicSection = (props: IProps) => {
    const { className, url, items = [], style = {}, displayTimeIn } = props;

    const renderItems = () => {
        if (ArrayUtils.isEmpty(items)) {
            return null;
        }
        return (
            <Element
                className={cn(
                    'bg-white',
                    'p-[15px]',
                    'rounded-[20px]',
                    'mt-[15px]'
                )}
            >
                <ContentList items={items} displayTimeIn={displayTimeIn} />
                <RouterLink
                    to={url}
                    newTab
                    className={cn(
                        'text-[1.5rem] text-[#2fa1b3] leading-[20px] font-semibold uppercase',
                        'block text-center',
                        'mt-[12px] pt-[12px]',
                        'border-t border-solid border-[#e9ecef]'
                    )}
                >
                    <span>Xem thêm</span>
                </RouterLink>
            </Element>
        );
    };

    return (
        <Element className="mt-[12px] pt-[12px] border-t border-solid border-[#e9ecef]">
            <Box className={cn(className, 'flex-col')} style={style}>
                <RouterLink to={url} newTab className="m-[-15px]">
                    <Image
                        className="w-full max-h-[120px]"
                        src={
                            'https://baomoi-static.bmcdn.me/wap/styles/img/event/milo/banner.jpg'
                        }
                        alt={props.title}
                    />
                </RouterLink>
                <>{renderItems()}</>
            </Box>
        </Element>
    );
};

export default memo(AdTopicSection);
